import { Services } from '@sigma-frontend-libs/commons'

import { propertiesSelect } from '@/utils'

export default {
  name: 'Properties',

  mixins: [ propertiesSelect({ serviceName: Services.servers }) ]
}
